import { useSessionStorage } from '@vueuse/core';
import { defineStore } from 'pinia';

import api from '@/api/api';
import { LOANS_HEADERS } from '@/constants/constants';
import { LOAN_SORTS } from '@/constants/constants';
import { BROKER_LOANS_BASE_URL } from '@/constants/urls';
import { LOG_PREFIX } from '@/types/enums';
import { SmartSearchResponse } from '@/types/responseTypes';

export default defineStore('loans', {
  state: () => ({
    loanDetails: {
      loanAmount: useSessionStorage('loanAmount', ''),
      loanTermInMonths: useSessionStorage('loanTermInMonths', ''),
      loanPurposeId: useSessionStorage('loanPurposeId', ''),
    },
    sortBy: LOAN_SORTS[0].value,
    hasEnquiryError: false,
    enquiryInProgress: false,
    hasResultsRequestCompleted: false,
    resultsQueryEnabled: false,
    enquiryId: '',
    pollCount: 0,
    pollingTimedOut: false,
  }),
  actions: {
    setEnquiryId(enquiryId: string) {
      this.enquiryId = enquiryId;
    },
    setLoanDetails(loanDetails: { loanAmount: ''; loanTermInMonths: ''; loanPurposeId: '' }) {
      this.loanDetails = loanDetails;
    },
    setHasResultsRequestCompleted(hasResultsRequestCompleted: boolean) {
      this.hasResultsRequestCompleted = hasResultsRequestCompleted;
    },
    setResultsQueryEnabled(resultsQueryEnabled: boolean) {
      this.resultsQueryEnabled = resultsQueryEnabled;
    },
    setPollCount(pollCount: number) {
      this.pollCount = pollCount;
    },
    setPollingTimedOut(pollingTimedOut: boolean) {
      this.pollingTimedOut = pollingTimedOut;
    },
    clearSession() {
      this.loanDetails.loanAmount = '';
      this.loanDetails.loanTermInMonths = '';
      this.loanDetails.loanPurposeId = '';
    },
    async getEnquiry() {
      this.hasEnquiryError = false;
      this.enquiryInProgress = true;

      const request = {
        settings: { resultsEmail: true },
        'smart-search': {
          userAgent: 'user-agent',
          user: {},
          goalCode: 'LOA_DEFAULT',
          payload: {
            loanDetails: this.loanDetails,
          },
        },
      };
      try {
        const { data } = await api<SmartSearchResponse>({
          url: `${BROKER_LOANS_BASE_URL}/smart-search`,
          method: 'post',
          data: request,
          headers: LOANS_HEADERS,
          logPrefix: `${LOG_PREFIX.LOANS} ENQUIRY`,
        });

        if (!data.enquiryId) {
          this.hasEnquiryError = true;
          window.$log.error(`${LOG_PREFIX.LOANS} ENQUIRY - Enquiry ID is missing in the response`, { responseData: data });
          return null;
        }

        this.setEnquiryId(data.enquiryId);
        return data;
      } catch (error) {
        this.hasEnquiryError = true;
        return null;
      } finally {
        this.enquiryInProgress = false;
      }
    },
  },
});
